import { render, staticRenderFns } from "./congrats.vue?vue&type=template&id=59d3c20e&"
import script from "./congrats.vue?vue&type=script&lang=js&"
export * from "./congrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports